import Axios from "axios";
import { api_url } from "../../../config";
import { normaliserErreurOperateur } from "../Operateurs/operateursApi";

// ============================================================
// Appels /parametrages-orientation (CE-1419), en français comme le contrat
// de l'API. Les erreurs sont normalisées comme celles des opérateurs : 400
// et 419 sous les champs (`champs`), 409 en bandeau (`code`, `message`).
// ============================================================

const TYPE = "SOUS_ORIENTATION";
const base = `${api_url}parametrages-orientation`;

const appel = (promesse) =>
  promesse.then(
    (res) => res.data,
    (err) => Promise.reject(normaliserErreurOperateur(err))
  );

export const listerVersions = () => appel(Axios.get(`${base}/${TYPE}`));

export const voirReferentiel = () => appel(Axios.get(`${base}/${TYPE}/referentiel`));

export const preparerVersion = (enVigueurLe) => appel(Axios.post(`${base}/${TYPE}/versions`, { enVigueurLe }));

export const voirVersion = (id) => appel(Axios.get(`${base}/versions/${id}`));

export const supprimerVersion = (id) => appel(Axios.delete(`${base}/versions/${id}`));

export const ajouterRegle = (versionId, corps) => appel(Axios.post(`${base}/versions/${versionId}/regles`, corps));

export const modifierRegle = (versionId, regleId, corps) => appel(Axios.put(`${base}/versions/${versionId}/regles/${regleId}`, corps));

export const supprimerRegle = (versionId, regleId) => appel(Axios.delete(`${base}/versions/${versionId}/regles/${regleId}`));

export const voirHistorique = (versionId, page) => appel(Axios.get(`${base}/versions/${versionId}/historique`, { params: { page } }));
